/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import "../../styles/containers/EditCheckup.scss";
import PaperCard from "../../components/PaperCard";
import { backgroundColor } from "../../Constants";
import { withStyles } from "@material-ui/core/styles";
import Rating from "@material-ui/lab/Rating";
import StarsIcon from "@material-ui/icons/Stars";
import Dropdown from "../../components/Dropdown";
import { Grid } from "@material-ui/core";
import { ratingColor } from "../../Constants";
import Loader from "../../components/Loader";
import {
  getAllStations,
  getModules,
  getTasks,
  addTaskDes,
  getTaskDes,
  updateTaskDes,
  fetchTaskDes,
  fetchTasks,
  fetchModules,
  getModulesAndStationRating,
  getAllCheckUpdates,
} from "../../store/actions/stationsActions";
import { connect } from "react-redux";
import { Storage } from "aws-amplify";
import { ToastContainer, toast } from "react-toastify";
import Message from "../../components/Message";
import { CollectionsOutlined } from "@material-ui/icons";

const StyledRating = withStyles({
  iconFilled: {
    color: ratingColor.red,
  },
  iconHover: {
    color: ratingColor.red,
  },
})(Rating);

function EditCheckup({
  getAllStations,
  getAllCheckUpdates,
  getModules,
  getTasks,
  isFetchedModules,
  isFetchedTasks,
  isFetchedStations,
  isFetchedCheckUpdates,
  tasks,
  modules,
  stations,
  modulesError,
  tasksError,
  stationsError,
  addTaskDes,
  addTaskDesError,
  addTaskDesSuccess,
  isFetchedTasksDes,
  tasksDes,
  tasksDesError,
  getTaskDes,
  updateTaskDes,
  updateTaskDesSuccess,
  updateTaskDesError,
  tasksDesSuccess,
  tasksSuccess,
  fetchTaskDes,
  fetchTasks,
  fetchModules,
  modulesMessage,
  getModulesAndStationRating,
  isFetchedRating,
  ratingError,
  ratingSuccess,
  modRating,
  stationRating,
  stationsSuccess,
  modulesSuccess,
  parkID,
  userError,
  dates,
  checkUpdatesSuccess,
}) {
  const [showTasks, setShowTasks] = useState({
    show: false,
    id: 0,
    index: null,
  });
  const [allModules, setAllModules] = useState([]);
  const [stationOptions, setstationOptions] = useState([
    { label: "Select Station", value: "" },
  ]);
  const [loading, setLoading] = useState(true);
  const [openDesPaper, setOpenDesPaper] = useState(false);
  const [error, setError] = useState(false);
  const [allTasks, setAllTasks] = useState([]);
  const [taskLoader, setTaskLoader] = useState({ loader: false, id: 0 });
  const [message, setMessage] = useState("");
  const [imageRemove, setImageRemove] = useState(false);
  const [temp, setTemp] = useState(0);
  const [dateOptions, setDateOptions] = useState([]);
  const [dDValues, setDDValues] = useState({
    date: "",
    station: "",
  });
  const [imageLoader, setImageLoader] = useState(false);

  useEffect(() => {
    if (parkID) {
      const data = {
        park_id: parseInt(parkID),
      };
      getAllCheckUpdates(data);
    }
  }, [parkID]);
  useEffect(() => {
    if (parkID && dDValues?.date?.value) {
      setLoading(true);
      const data = {
        park_id: parseInt(parkID),
        date: dDValues?.date?.value,
      };
      getAllStations(data);
    } else {
      let stationOptions = [{ label: "Select Station", value: "" }];
      setstationOptions(stationOptions);
      setMessage("Please Select Date");
    }
  }, [dDValues.date]);

  useEffect(() => {
    return () => {
      fetchTaskDes();
      fetchTasks();
    };
  }, []);

  useEffect(() => {
    if (userError) setLoading(false);
  }, [userError]);

  useEffect(() => {
    if (stationsSuccess && isFetchedStations) {
      let stationOptions = [{ label: "Select Station", value: "" }];
      if (stations?.length) {
        stations.map((station, index) =>
          stationOptions.push({
            value: `${station.id}T${index}`,
            label: station.name,
          })
        );
        setstationOptions(stationOptions);
        setError("");
      } else {
        setMessage("No Checkup Exists");
        setLoading(false);
      }
      setDDValues({
        ...dDValues,
        station: stationOptions.length > 1 ? stationOptions[0] : "",
      });
      setLoading(false);
    } else if (stationsError) {
      setLoading(false);
      toast.error(`Error in getting stations ${stationsError}`);
      fetchModules();
    }
  }, [isFetchedStations]);

  useEffect(() => {
    if (checkUpdatesSuccess && isFetchedCheckUpdates) {
      let stationOptions = [{ label: "Select Station", value: "" }];
      let dateOptions = [{ label: "Select Date", value: "" }];
      if (stations?.length) {
        stations.map((station, index) =>
          stationOptions.push({
            value: `${station.id}T${index}`,
            label: station.name,
          })
        );
        setstationOptions(stationOptions);
        setError("");
      }
      if (dates?.length) {
        dates.map((val) =>
          dateOptions.push({
            value: val.split("T")[0],
            label: val.split("T")[0],
          })
        );
        setDateOptions(dateOptions);
      } else {
        setMessage("No Checkup Exists");
        setLoading(false);
      }
      setDDValues({
        station: stationOptions.length > 1 ? stationOptions[0] : "",
        date: dateOptions.length > 1 ? dateOptions[1] : "",
      });
    } else if (stationsError) {
      setLoading(false);
      toast.error(`Error in getting stations ${stationsError}`);
      fetchModules();
    }
  }, [isFetchedCheckUpdates]);

  useEffect(() => {
    if (dDValues.date.value && dDValues?.station?.value) {
      const data = {
        date: dDValues.date.value,
        station_id: dDValues.station.value.split("T")[0],
        park_id: parseInt(parkID),
      };
      const ratingData = {
        date: dDValues.date.value,
        station_name: dDValues.station.label,
        park_id: parseInt(parkID),
      };
      getModules(data);
      getModulesAndStationRating(ratingData);
      setLoading(true);
      setAllTasks([]);
      setShowTasks({ show: false, id: 0, index: null });
    } else if (dDValues.date.value && !dDValues.station.value) {
      setMessage("Please Select Station");
    }
  }, [dDValues.station]);

  useEffect(() => {
    if (isFetchedModules && modulesSuccess) {
      if (modules?.length) {
        setAllModules(modules);
        setError("");
        setMessage("");
      } else if (modulesMessage && dDValues.station.value) {
        setMessage(modulesMessage);
        setLoading(false);
      }
    } else if (modulesError && dDValues.station.value) {
      setAllModules([]);
      setLoading(false);
      toast.error(`Error in getting modules ${modulesError}`);
      fetchModules();
      setMessage("");
    }
  }, [isFetchedModules]);

  useEffect(() => {
    if (isFetchedRating && ratingSuccess && dDValues.station.value) {
      let val = dDValues;
      val.station.ratingValue = stationRating;
      setDDValues(val);

      if (isFetchedModules && modulesSuccess) {
        setAllModules((previousData) => {
          let preData = [...previousData];
          preData.map((mod) =>
            modRating.filter((module) =>
              module.module_name === mod.name
                ? (mod.ratingValue = module.min)
                : ""
            )
          );
          return preData;
        });
      }

      setLoading(false);
    } else if (ratingError && isFetchedRating) {
      toast.error(`Error occured in getting modules rating ${ratingError}`);
      setLoading(false);
    }
  }, [isFetchedRating && isFetchedModules]);

  useEffect(() => {
    if (showTasks.id) {
      setTaskLoader({ loader: true, id: showTasks.index });
      const data = {
        module_id: showTasks.id,
        park_id: parseInt(parkID),
        date: dDValues.date.value,
      };
      getTasks(data);
      setShowTasks({ ...showTasks, show: true });
    }
  }, [showTasks.index]);

  useEffect(() => {
    if (tasks?.length && tasksSuccess && dDValues.station.value) {
      setAllTasks(tasks);
      setError("");
      const data = {
        station_name: dDValues.station.label,
        module_name: allModules[showTasks.index].name,
        date: dDValues.date.value,
        park_id: parseInt(parkID),
      };
      getTaskDes(data);
    } else if (tasksError) {
      setTaskLoader({ id: taskLoader.id, loader: false });
      toast.error("Error in getting tasks", tasksError);
    }
  }, [isFetchedTasks]);

  useEffect(() => {
    if (tasksDes?.length && tasksDesSuccess) {
      let alltasks = [...allTasks];
      tasksDes.map((taskDes) =>
        alltasks.forEach((task) => {
          if (task.id === taskDes.task_id) {
            task.description = taskDes.task_description
              ? taskDes.task_description
              : "";
            task.ratingValue = taskDes.rating ? taskDes.rating : 0;
            task.update = true;
            task.images = taskDes.image_url;
            if (task.description || task.ratingValue || task.images?.length)
              task.backgroundColor = backgroundColor.green;
            setTemp(Date.now());
          }
        })
      );
      setAllTasks(alltasks);
      setError("");
      setTaskLoader({ id: taskLoader.id, loader: false });
    } else if (tasksDesSuccess && isFetchedTasksDes) {
      setTaskLoader({ id: taskLoader.id, loader: false });
    } else if (tasksDesError && isFetchedTasksDes) {
      setError("");
      setTaskLoader({ id: taskLoader.id, loader: false });
      toast.error(`Error in getting description ${tasksDesError}`);
    }
  }, [isFetchedTasksDes]);

  useEffect(() => {
    if (allTasks.length) {
      if (updateTaskDesSuccess && !imageRemove) {
        setAllTasks((previousData) => {
          let preData = [...previousData];
          preData[openDesPaper.index].open = false;
          preData[openDesPaper.index].loading = false;
          preData[openDesPaper.index].update = true;
          preData[openDesPaper.index].backgroundColor = backgroundColor.green;
          return preData;
        });
        setError("");
        setTemp(Date.now());

        const ratingData = {
          date: dDValues.date.value,
          station_name: dDValues.station.label,
          park_id: parseInt(parkID),
        };
        getModulesAndStationRating(ratingData);
      } else if (addTaskDesSuccess && imageRemove) {
        setAllTasks((previousData) => {
          let preData = [...previousData];
          preData[openDesPaper.index].update = true;
          return preData;
        });
        setError("");
        setTemp(Date.now());
      }
      setImageLoader(false);
    }
  }, [updateTaskDesSuccess]);

  useEffect(() => {
    if (allTasks.length) {
      if (addTaskDesSuccess && !imageRemove) {
        setAllTasks((previousData) => {
          let preData = [...previousData];
          preData[openDesPaper.index].open = false;
          preData[openDesPaper.index].loading = false;
          preData[openDesPaper.index].update = true;
          preData[openDesPaper.index].backgroundColor = backgroundColor.green;
          return preData;
        });
        setError("");
        setTemp(Date.now());
        const ratingData = {
          date: dDValues.date.value,
          station_name: dDValues.station.label,
          park_id: parseInt(parkID),
        };
        getModulesAndStationRating(ratingData);
      } else if (addTaskDesSuccess && imageRemove) {
        setAllTasks((previousData) => {
          let preData = [...previousData];
          preData[openDesPaper.index].update = true;
          return preData;
        });
        setError("");
        setTemp(Date.now());
      }
      setImageLoader(false);
    }
  }, [addTaskDesSuccess]);

  useEffect(() => {
    if (allTasks.length) {
      setAllTasks((previousData) => {
        let preData = [...previousData];
        preData[openDesPaper.index].loading = false;
        return preData;
      });
      setError(addTaskDesError);
    }
  }, [addTaskDesError]);

  useEffect(() => {
    if (allTasks.length) {
      setAllTasks((previousData) => {
        let preData = [...previousData];
        preData[openDesPaper.index].loading = false;
        return preData;
      });
      setError(updateTaskDesError);
    }
  }, [updateTaskDesError]);

  const onClickHeading = (id, index) => {
    setShowTasks({ show: !showTasks.show, id, index });
  };

  const onChangeDes = (event, index) => {
    setAllTasks((previousData) => {
      let preData = [...previousData];
      preData[index][event.target.name] = event.target.value;
      return preData;
    });
    setError("");
  };

  const onSave = (index, subIndex) => {
    const data = {
      task_id: allTasks[subIndex].id,
      task_name: allTasks[subIndex].name,
      module_name: allModules[index].name,
      module_id: allModules[index].id,
      task_description: allTasks[subIndex].description,
      user_id: localStorage.getItem("userID"),
      user_name: localStorage.getItem("userName"),
      image_url: allTasks[subIndex].images,
      station_id: dDValues.station.value.split("T")[0],
      station_name: dDValues.station.label,
      date: dDValues.date.value,
      rating: allTasks[subIndex].ratingValue,
      park_id: parseInt(parkID),
    };

    if (!data.task_description && !data.image_url?.length && !data.rating) {
      return setAllTasks((previousData) => {
        let preData = [...previousData];
        preData[openDesPaper.index].open = false;
        preData[openDesPaper.index].loading = false;
        return preData;
      });
    }

    allTasks[subIndex].update ? updateTaskDes(data) : addTaskDes(data);
    setAllTasks((previousData) => {
      let preData = [...previousData];
      preData[subIndex].loading = true;
      return preData;
    });
    setImageRemove(false);
  };
  const onChangeRating = (e, val, index) => {
    setAllTasks((previousData) => {
      let preData = [...previousData];
      preData[index].ratingValue = val;

      return preData;
    });
  };

  const handleDDValues = (val, nameObj) => {
    const name = nameObj.name;
    setDDValues({
      ...dDValues,
      [name]: val,
    });
  };

  const handleOpenDesPaper = (index, open) => {
    if (openDesPaper) {
      setAllTasks((previousData) => {
        let preData = [...previousData];
        if (preData[openDesPaper.index])
          if (!preData[openDesPaper.index].loading) {
            preData[openDesPaper.index].open = false;

            if (preData[index]) preData[index].open = open;
            setOpenDesPaper({ index, open });
          }
        return preData;
      });
    } else {
      setOpenDesPaper({ index, open });
      setAllTasks((previousData) => {
        let preData = [...previousData];
        preData[index].open = open;
        return preData;
      });
    }
    setError("");
    setImageRemove(false);
  };

  const onChangeImage = (e, index, subIndex) => {
    const image = e.target.files;

    let newImages = image ? Array.from(image) : [];
    if (newImages.length) {
      setImageLoader(true);
      Promise.all(
        newImages.map((img, ind) => {
          let preData = [...allTasks];
          return Storage.put(img.name, img).then((res) => {
            if (preData[subIndex].images) {
              if (preData[subIndex].images?.length) {
                preData[subIndex].images.push(res.key);
              } else {
                let allImages = [...preData[subIndex].images];
                allImages.push(res.key);
                preData[subIndex].images = allImages;
              }
            } else {
              preData[subIndex].images = [res.key];
            }
            setAllTasks(preData);
            return res.key;
          });
        })
      )
        .then((res) => {
          let preData = [...allTasks];
          const data = {
            task_id: preData[subIndex].id,
            task_name: preData[subIndex].name,
            module_name: allModules[index].name,
            module_id: allModules[index].id,
            task_description: "",
            user_id: localStorage.getItem("userID"),
            user_name: localStorage.getItem("userName"),
            image_url: preData[subIndex].images,
            station_id: dDValues.station.value.split("T")[0],
            station_name: dDValues.station.label,
            date: dDValues.date.value,
            park_id: parseInt(parkID),
          };
          preData[subIndex].update ? updateTaskDes(data) : addTaskDes(data);
          setImageRemove(true);
        })
        .catch((err) => {
          toast.error(`Error in storing image ${err.message}`);
        });
      setTemp(Date.now());
    }
  };

  const onRemoveImage = (subIndex, imageIndex, index) => {
    let preData = [...allTasks];
    Storage.remove(preData[subIndex].images[imageIndex])
      .then(() => {
        preData[subIndex].images.splice(imageIndex, 1);
        setAllTasks(preData);
        const data = {
          task_id: preData[subIndex].id,
          task_name: preData[subIndex].name,
          module_name: allModules[index].name,
          module_id: allModules[index].id,
          task_description: "",
          user_id: localStorage.getItem("userID"),
          user_name: localStorage.getItem("userName"),
          image_url: preData[subIndex].images,
          station_id: dDValues.station.value.split("T")[0],
          station_name: dDValues.station.label,
          date: dDValues.date.value,
          park_id: parseInt(parkID),
        };
        preData[subIndex].update ? updateTaskDes(data) : addTaskDes(data);
        setImageRemove(true);
        setTemp(Date.now());
      })
      .catch((err) => toast.error(`picture removed error ${err.message}`));
  };

  return (
    <div
      className="EditCheckup"
      style={loading || message ? { height: "100vh" } : { height: "100%" }}
    >
      <Grid container justify="space-between">
        <Grid item xs={5} md={4}>
          <Dropdown
            options={dateOptions}
            placeholder="Select Date"
            id="date"
            name="date"
            value={dDValues.date}
            onChange={handleDDValues}
            key="date"
          />
        </Grid>
        <Grid item xs={5} md={4}>
          <Dropdown
            options={stationOptions}
            placeholder="Select Station"
            id="station"
            value={dDValues.station}
            name="station"
            onChange={handleDDValues}
            key="station"
          />
        </Grid>
      </Grid>

      {loading ? (
        <Loader />
      ) : message ? (
        <Message message={message} />
      ) : dDValues.station.value ? (
        <>
          <div className="main" key="main-heading">
            <h1 className="main-heading" key="heading">
              {dDValues.station.label}
            </h1>
            <span className="rating-box" key="index">
              <StyledRating
                name="customized-color"
                defaultValue={0}
                getLabelText={(value) =>
                  `${value} Star${value !== 1 ? "s" : ""}`
                }
                precision={1}
                icon={<StarsIcon fontSize="inherit" />}
                className="rating"
                emptyIcon={
                  <StarsIcon
                    fontSize="inherit"
                    style={{ color: backgroundColor.grey }}
                  />
                }
                readOnly
                value={dDValues.station.ratingValue}
              />
            </span>
          </div>

          {allModules.map((module, index) => (
            <>
              <PaperCard
                heading={module.name}
                id={index}
                editCheckup={false}
                onClickHeading={() => onClickHeading(module.id, index)}
                main={true}
                taskLoader={taskLoader}
                taskIndex={index}
                ratingReadonly={true}
                ratingValue={module.ratingValue}
                ratingColor={
                  module.ratingValue >= 1 && module.ratingValue < 3
                    ? ratingColor.red
                    : module.ratingValue >= 3 && module.ratingValue < 4
                    ? ratingColor.yellow
                    : ratingColor.green
                }
                key={`module ${index}`}
              />
              {index === showTasks.index &&
              showTasks.show &&
              allTasks.length &&
              !taskLoader.loader
                ? allTasks.map((task, subIndex) => {
                    return (
                      <PaperCard
                        heading={task.name}
                        description={task.description}
                        noPadding={true}
                        ratingColor={
                          task.ratingValue >= 1 && task.ratingValue < 3
                            ? ratingColor.red
                            : task.ratingValue >= 3 && task.ratingValue < 4
                            ? ratingColor.yellow
                            : ratingColor.green
                        }
                        ratingValue={task.ratingValue}
                        backgroundColor={
                          task.backgroundColor
                            ? task.backgroundColor
                            : backgroundColor.gray
                        }
                        main={false}
                        ratingReadonly={false}
                        id={`${index} - ${subIndex}`}
                        editCheckup={true}
                        onChangeDes={(event) => onChangeDes(event, subIndex)}
                        onSave={() => onSave(index, subIndex)}
                        onChangeRating={(e, val) => {
                          onChangeRating(e, val, subIndex);
                          handleOpenDesPaper(subIndex, true);
                        }}
                        error={error}
                        loading={task.loading}
                        openPaper={task.open}
                        // onClickHeading={(openPaper) => onClickHeading(openPaper)}
                        handleOpenDesPaper={(open) =>
                          handleOpenDesPaper(subIndex, open)
                        }
                        onChangeImage={(e) => onChangeImage(e, index, subIndex)}
                        images={task.images}
                        onRemoveImage={(image) =>
                          onRemoveImage(subIndex, image, index)
                        }
                        imageLoader={imageLoader}
                        temp={temp}
                        key={`${index}+${subIndex}`}
                      />
                    );
                  })
                : ""}
            </>
          ))}
        </>
      ) : (
        ""
      )}
      <ToastContainer position={toast.POSITION.TOP_RIGHT} autoClose={2000} />
    </div>
  );
}

function mapStateToProps(state) {
  return {
    isFetchedCheckUpdates: state?.stations?.checkUpdates?.isFetched,
    isFetchedStations: state?.stations?.stations?.isFetched,
    isFetchedModules: state?.stations?.modules?.isFetched,
    isFetchedTasks: state?.stations?.tasks?.isFetched,
    stations: state?.stations?.stations?.stations,
    dates: state?.stations?.checkUpdates?.dates,
    stationsSuccess: state?.stations?.stations?.success,
    tasks: state?.stations?.tasks?.tasks,
    tasksSuccess: state?.stations?.tasks?.success,
    modules: state?.stations?.modules?.modules,
    modulesMessage: state?.stations?.modules?.message,
    modulesError: state?.stations?.modules?.error,
    modulesSuccess: state?.stations?.modules?.success,
    tasksError: state?.stations?.tasks?.error,
    stationsError: state?.stations?.stations?.error,
    isPostDes: state?.stations?.addTaskDes?.isPost,
    addTaskDesError: state?.stations?.addTaskDes?.error,
    addTaskDesMessage: state?.stations?.addTaskDes?.message,
    addTaskDesSuccess: state?.stations?.addTaskDes?.success,
    tasksDes: state?.stations?.tasksDes?.tasksDes,
    tasksDesError: state?.stations?.tasksDes?.error,
    isFetchedTasksDes: state?.stations?.tasksDes?.isFetched,
    tasksDesSuccess: state?.stations?.tasksDes?.success,
    isUpdateTaskDes: state?.stations?.updateTaskDes?.isUpdate,
    updateTaskDesSuccess: state?.stations?.updateTaskDes?.success,
    updateTaskDesError: state?.stations?.updateTaskDes?.error,
    updateTaskDesMessage: state?.stations?.updateTaskDes?.message,
    isFetchedRating: state?.stations?.modAndStationRating?.isFetched,
    ratingError: state?.stations?.modAndStationRating?.error,
    ratingSuccess: state?.stations?.modAndStationRating?.success,
    modRating: state?.stations?.modAndStationRating?.modRating,
    stationRating: state?.stations?.modAndStationRating?.stationRating,
    userName: state?.users?.getUser?.user?.userName,
    parkID: state?.users?.getUser?.user?.park_id,
    userError: state?.users?.getUser?.error,
    checkUpdatesSuccess: state?.stations?.checkUpdates?.success,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getAllCheckUpdates: (data) => dispatch(getAllCheckUpdates(data)),
    getAllStations: (data) => dispatch(getAllStations(data)),
    getModules: (data) => dispatch(getModules(data)),
    getTasks: (data) => dispatch(getTasks(data)),
    addTaskDes: (data) => dispatch(addTaskDes(data)),
    getTaskDes: (data) => dispatch(getTaskDes(data)),
    updateTaskDes: (data) => dispatch(updateTaskDes(data)),
    fetchTaskDes: () => dispatch(fetchTaskDes()),
    fetchTasks: () => dispatch(fetchTasks()),
    fetchModules: () => dispatch(fetchModules()),
    getModulesAndStationRating: (data) =>
      dispatch(getModulesAndStationRating(data)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditCheckup);
